import React from "react";
import { Alert } from "antd";

const ErrorState = ({ message }) => (
  <Alert type="error" showIcon message={message} className="error-state" />
);

export default ErrorState;
